import type { DeviceGroupAttribute, GraphPath, Layout } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SetPathLayoutsCommand {
  groupBy: DeviceGroupAttribute;
  options: {
    path: GraphPath;
    layout: Layout;
  }[];
}

/**
 * Set path layouts both default and currently edited values
 */
export const setPathLayouts: GraphCommandFactory<SetPathLayoutsCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      for (const option of command.options) {
        draft.pathLayouts[command.groupBy][option.path] = option.layout;
        draft.defaultPathLayouts[command.groupBy][option.path] = option.layout;
      }
    });
  };
